import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { getStoredAuth, clearStoredAuth } from "../../utils/authStorage";

function PrivateRoute({ isAuthenticated, children }) {
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);
  const [isValid, setIsValid] = useState(false);
  
  useEffect(() => {
    const { token, user, vehicle } = getStoredAuth();
    const hasUser = user || vehicle;
    
    if (token && hasUser) {
      try {
        setIsValid(true);
      } catch {
        clearStoredAuth();
        setIsValid(false);
      }
    } else {
      setIsValid(false);
    }
    setIsChecking(false);
  }, [isAuthenticated]);

  if (isChecking) {
    return null;
  }

  if (!(isAuthenticated && isValid)) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
}

export default PrivateRoute;
